export enum SyncState {
  MODIFED = "MODIFIED",
  UPLOAD = "UPLOAD",
  UPLOADED = "UPLOADED",
}
